import { onDocumentReady } from "@story/story_assets/utils";

onDocumentReady(function() {
	let header = document.querySelector(".page-header");

	function onResize() {
		header.classList.toggle("opaque", 10 < window.scrollY);
	}

	window.addEventListener("load", onResize);
	window.addEventListener("scroll", onResize);
	window.addEventListener("resize", onResize);
	window.addEventListener("orientationchange", onResize);

	onResize();

	let observer = new IntersectionObserver(function(entries) {
		for (let entry of entries) {
			if (entry.isIntersecting) {
				let element = entry.target;
				element.classList.add("animated");
				observer.unobserve(element);
			}
		}
	}, {
		threshold: 1.0
	});

	for (let button of document.querySelectorAll(".btn-animated:not(.animated)")) {
		observer.observe(button);
	}
});